module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/ja/3-be69c9ea55ab4e663057490bc164d5b6.jpg";